var _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgEditIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.7657 1.07565L14.9229 2.23279C15.6 2.90136 15.6 3.98993 14.9229 4.6585L3.58286 15.9985H0V12.4156L8.91429 3.49279L11.34 1.07565C12.0086 0.407076 13.0971 0.407076 13.7657 1.07565ZM1.71429 14.2842L2.92286 14.3356L11.34 5.90993L10.1314 4.70136L1.71429 13.1185V14.2842Z",
    fill: "#006BD7"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEditIcon);
export default __webpack_public_path__ + "static/media/EditIcon.9a473d33470d1b700598dc9e1de69926.svg";
export { ForwardRef as ReactComponent };